var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M439.781 145.387L394.352 64.623C383.016 44.471 361.691 32 338.57 32H109.43C86.309 32 64.984 44.471 53.648 64.623L8.219 145.387C2.83 154.967 0 165.773 0 176.764V416C0 451.346 28.654 480 64 480H384C419.346 480 448 451.346 448 416V176.764C448 165.773 445.17 154.967 439.781 145.387ZM352.516 88.154L392.182 158.672H247.016V80H338.57C344.342 80 349.686 83.125 352.516 88.154ZM95.484 88.154C98.314 83.125 103.658 80 109.43 80H199.016V158.672H55.818L95.484 88.154ZM384 432H64C55.178 432 48 424.822 48 416V206.672H400V416C400 424.822 392.822 432 384 432Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.cb54a2a307aef50c4c5ef46263e6a510.svg";
export { ForwardRef as ReactComponent };